// @flow

import React, { type Node } from 'react';
import { useCurrentReceipt, getTransactionFees } from '@tectonics/prs/receipts';
import { getCountry, useIncomingPayment } from '@tectonics/prs/incoming-payment';
import { amountToCurrencyString } from '@tectonics/prs/money';
import { getMoneyFormat } from '../../../commons/money-format';
import { Tooltip } from './tooltip';
import {
  SideDisplayValueItem,
  SideDisplayValueItemTitle,
  SideDisplayValueItemValue,
} from '../side-display-values';


export function DisplayCDPTransactionFee(): Node {
  const incomingPayment = useIncomingPayment();
  const receipt = useCurrentReceipt();
  const fee = getTransactionFees(receipt, 'CDP');

  const country = getCountry(incomingPayment);
  const formatAmount = amountToCurrencyString(getMoneyFormat(country));

  if (!fee) return null;

  return (
    <SideDisplayValueItem data-testid="display_cdp_transaction_fee">
      <SideDisplayValueItemTitle>
        CDP <Tooltip />
      </SideDisplayValueItemTitle>
      <SideDisplayValueItemValue>
        {formatAmount(fee.amount)}
      </SideDisplayValueItemValue>
    </SideDisplayValueItem>
  );
}
